import { useEffect, useState } from "react";
import { FolderIcon } from "../../icons";
import { Modal } from "../CommonUIComponents/Modal/Modal";
import { Select } from "../CommonUIComponents/Select/Select";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "../CommonUIComponents/Button/Button";
import { CancelBtn, DataHostingLocation, DataStorageLocation, SubmitBtn, RegionModalBody } from "../../util/constants";
import { routes } from "../../routes/routes.constatns";
import { Link } from "react-router-dom";
import { setSelectedRegionForDemoEngagement } from "../../store/slices/engagementSlice";

function ModalHeader() {
  return (
    <div className="file-version-history-modal-header">
      <div className="motif-fab">
        <FolderIcon />
      </div>
      <span>{DataHostingLocation}</span>
    </div>
  );
}

function ModalBody({ onChange, value, options }) {
  return (
    <div style={{ display: "flex", gap: "2rem", flexDirection: "column" }}>
      <span>
        {RegionModalBody}
      </span>
      <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
        <span style={{ color: "#a4a3b1" }}>
          {DataStorageLocation} <span className="required-star">*</span>
        </span>
        <Select onChange={onChange} value={value} options={options} />
      </div>
    </div>
  );
}

function ModalFooter({
  handleCancelClick,
  selectedValue,
  engagementId,
  regionList,
  isSandboxEngagement = false,
  onSubmit = () => {},
}) {
  const dispatch = useDispatch();

  let url = "";

  if (selectedValue && !isSandboxEngagement) {
    var regionUrl = regionList.find((x) => x.id === selectedValue).appUrl;
    url = `${regionUrl}${routes.createNewEngagement}?regionId=${selectedValue}`;

    if (engagementId) {
      url = url + `&engagementId=${engagementId}`;
    }
  }

  function handleSelectedDemoEngagement() {
    // For demo engagement, redirect to US region always
    var regionId = regionList.find((x) => x.id === selectedValue).id;
    dispatch(setSelectedRegionForDemoEngagement({ regId: regionId }));
    onSubmit();
    handleCancelClick();
  }

  return (
    <div className="view-endagement-delete-modal-footer">
      <Button variant="secondary" onClick={handleCancelClick}>
        {CancelBtn}
      </Button>
      {!isSandboxEngagement ? <Link
        to={url}
        className={`motif-button motif-button-primary motif-button-large decarb-button ${!selectedValue ? "decarb-text-area-hide-label" : ""
          }`}
        disabled={!selectedValue}
      >
        {SubmitBtn}
      </Link> : <Button
        variant="primary"
        disabled={!selectedValue}
        onClick={handleSelectedDemoEngagement}
        className={!selectedValue ? "decarb-text-area-hide-label" : ""}
      >
        {SubmitBtn}
      </Button>}
      <Button
        variant="primary"
        disabled={!selectedValue}
        className={selectedValue ? "decarb-text-area-hide-label" : ""}
      >
        {SubmitBtn}
      </Button>
    </div>
  );
}

export function SelectRegionModal({
  isModalVisible,
  onClose,
  engagementId = "",
  isSandboxEngagement = false,
  onSubmit = () => { },
}) {
  const [selectedValue, setSelectedValue] = useState(0);
  const regionList = useSelector((state) => state.engagement.regionList);
  const [optionsList, setOptionsList] = useState([]);
  function onChange(value) {
    setSelectedValue(parseInt(value));
  }

  useEffect(
    () => () => {
      setSelectedValue(0);
    },
    []
  );
  useEffect(() => {
    let array = [];
    regionList.forEach((element) => {
      if (element.id === 1) {
        array.push({ id: element.id, name: "United States - Americas" });
      } else if (element.id === 2) {
        array.push({ id: element.id, name: "Singapore - APAC" });
      } else {
        array.push({ id: element.id, name: "Netherlands - EMEIA" });
      }
    });
    setOptionsList(array);
  }, [regionList]);

  return (
    <Modal
      show={isModalVisible}
      onClose={onClose}
      header={<ModalHeader />}
      body={
        <ModalBody
          onChange={onChange}
          value={selectedValue}
          options={optionsList}
        />
      }
      footer={
        <ModalFooter
          handleCancelClick={() => {
            onClose();
            setSelectedValue(0);
          }}
          onSubmit={onSubmit}
          selectedValue={selectedValue}
          engagementId={engagementId}
          regionList={regionList}
          isSandboxEngagement={isSandboxEngagement}
        />
      }
      className={"change-region-modal"}
    />
  );
}
